import { Users } from '@platform/client';
import { Button, Card } from '@platform/components';
import Skeleton from 'react-loading-skeleton';
import ProUserMyProjects from './ProUserMyProjects';
import RepUserMyProjects from './RepUserMyProjects';
import { IntroductionModalProvider } from './Modals/IntroductionModal';
import { UpdateProjectDatesModalProvider } from './Modals/UpdateProjectDatesModal';

export enum DiscoveryCallModalStage {
  //Initial stage
  Update_Selection = 'update-selection',

  Outcome_Selection = 'outcome-selection',
  Match_Confirming = 'match-confirming',
  Custom_Naming = 'custom-naming',
  Match_Confirmed = 'match-confirmed',
  Match_Declining = 'match-declining',
  Match_Declined = 'match-declined',
  Match_Need_Help = 'match-need-help',

  Unresponsive = 'unresponsive',
  Other = 'other',
  Update_Confirmed = 'other-confirmed',
}
// likely doesn't need to be here
export const ProjectType = {
  mentor: 'Mentor',
  trainer: 'Trainer',
  coach: 'Coach',
  consultant: 'Consultant',
  doer: 'Consultant', //Legacy status, now maps to Consultant per product request
};

const MyProjectsPage = () => {
  const user = Users.useGetCurrentUser();
  const isRepresentative =
    user.isSuccess &&
    (user.data.role === 'representative' || user.data.role === 'representative_with_opportunity');

  if (!user.isSuccess) {
    return (
      <div className='px-10 flex flex-col md:w-full max-w-[910px] pb-12 md:pb-36 gap-6'>
        <div className='text-3xl flex flex-row justify-between mb-4'>My Projects</div>
        {[1, 2, 3].map((_, index) => (
          <div key={index}>
            <Card
              headerContent='&nbsp;'
              headerColor='gray-50'
              buttonText=''
              buttonDisabled={true}
              content={<Skeleton className='w-48' />}
              contentSubText='&nbsp;'
              avatarSize='md'
              badges={[]}
              variant='small'
              buttonOnClick={() => {}}
            />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className='px-10 flex flex-col md:w-full max-w-[910px] pb-12 md:pb-36'>
      <div className='text-display-sm flex flex-row justify-between'>
        My Projects
        {isRepresentative && (
          <Button
            href={`${import.meta.env['VITE_LEGACY_APP_URL']}/dashboard/organization/request`}
            variant='secondary-color'
            leadIcon='plus'
            size='sm'
            additionalClassnames='text-xs md:text-sm'
          >
            Create project
          </Button>
        )}
        {!isRepresentative && (
          <Button
            href={'/platform/project-search'}
            variant='secondary-color'
            leadIcon='search-lg'
            size='sm'
            additionalClassnames='text-xs md:text-sm'
            target='_blank'
          >
            Find projects
          </Button>
        )}
      </div>
      <IntroductionModalProvider>
        <UpdateProjectDatesModalProvider>
          {isRepresentative && <RepUserMyProjects />}
          {!isRepresentative && <ProUserMyProjects />}
          {/* <CancelPendingIntroductionsModal /> */}
        </UpdateProjectDatesModalProvider>
      </IntroductionModalProvider>
    </div>
  );
};

export default MyProjectsPage;
